<template>
    <select v-model="gender">
        <option :value="null">All</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
    </select>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Control from 'components/form/Control.vue';

    export default {
        name: 'gender',
        components: {
            Control,
        },
        computed: {
            ...mapState('discountRateComparison', {
                getGender: 'gender',
            }),
            gender: {
                get() {
                    return this.getGender;
                },
                set(value) {
                    this.update({ key: 'gender', value });
                },
            },
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'update',
            ]),
        }
    }
</script>



// WEBPACK FOOTER //
// Gender.vue?b05d2bb6